import { ProgramTypes } from 'legacy/lut/classes/models/ProgramTypes'

import { IFileSettings } from 'core-components/library/dragNDropFileUploader'
import { saveFile } from 'core/classes/helpers/saveFiles'

import { getPartnerContactsCrud } from '../lib/getPartnerContactsCrud'
import { IPartnerContact } from '../model/types'

interface IParams {
  partnerId: string
  programType: ProgramTypes
  filesInfo: IFileSettings[]
  contact: IPartnerContact
}

export const uploadContactImage = async ({
  partnerId,
  programType,
  filesInfo,
  contact,
}: IParams) => {
  const crud = getPartnerContactsCrud({ partnerId, programType })

  const images = filesInfo.map((image) => ({
    file: image.file,
    EntryId: contact.EntryId,
    UID: contact.UID,
  }))

  await saveFile({
    formId: 700,
    formCode: 'PartnerContacts',
    fieldName: 'Image',
    models: images,
    source: crud,
  })
}
